module.exports = (__webpack_require__("xDzS"))(18);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/is-buffer/index.js from dll-reference common_library
// module id = Re3r
// module chunks = 16 17 18 19